export const TemplateStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  Complete: 'Complete',
  Draft: 'Draft',
}
